import _styled from "styled-components";
import { useTranslation } from 'next-i18next';
import { Button, Title } from '../../../';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CoverLetterQuickGuide = function CoverLetterQuickGuide(_ref) {
  var onClose = _ref.onClose,
      _ref$showCloseButton = _ref.showCloseButton,
      showCloseButton = _ref$showCloseButton === void 0 ? true : _ref$showCloseButton;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(_StyledDiv, {
    children: [/*#__PURE__*/_jsxs(_StyledDiv2, {
      children: [/*#__PURE__*/_jsx(Title, {
        content: t('onboarding-page:very_short_guide_to_present_yourself_at_your_best'),
        fontSize: "superLarge",
        fontWeight: "semibold",
        twStyle: {
          "lineHeight": "1.688rem"
        }
      }), /*#__PURE__*/_jsx(Title, {
        content: t('onboarding-page:the_best_advice_from_our_team'),
        fontSize: "small",
        fontWeight: "normal",
        twStyle: {
          "lineHeight": "1.5rem"
        },
        textColor: "gray"
      })]
    }), /*#__PURE__*/_jsxs(_StyledDiv3, {
      children: [/*#__PURE__*/_jsx(_StyledDiv4, {
        children: /*#__PURE__*/_jsx(Title, {
          fontSize: "base",
          content: t('onboarding-page:4_tips_with_the_love'),
          textColor: "bold-purple",
          twStyle: {
            "lineHeight": "1.5rem"
          },
          fontWeight: "semibold"
        })
      }), /*#__PURE__*/_jsx(QuickGuideTitleAndSubTitle, {
        title: t('onboarding-page:be_essential_and_clear'),
        subTitle: t('onboarding-page:would_you_read_a_very_long_text')
      }), /*#__PURE__*/_jsx(QuickGuideTitleAndSubTitle, {
        title: t('onboarding-page:write_well_spelling_and_grammar'),
        subTitle: t('onboarding-page:if_italian_is_not_your_native_language_try_your_best')
      }), /*#__PURE__*/_jsx(QuickGuideTitleAndSubTitle, {
        title: t('onboarding-page:talk_about_why_youre_running_and_why_they_should_choose_you')
      }), /*#__PURE__*/_jsx(QuickGuideTitleAndSubTitle, {
        title: t('onboarding-page:be_original'),
        subTitle: t('onboarding-page:companies_receive_many_letters_every_day_all_the_samedifferentiated')
      })]
    }), showCloseButton ? /*#__PURE__*/_jsx(Button, {
      variant: "normal",
      title: t('common:close'),
      fullwidth: true,
      onClick: onClose
    }) : null]
  });
};

var QuickGuideTitleAndSubTitle = function QuickGuideTitleAndSubTitle(_ref2) {
  var title = _ref2.title,
      subTitle = _ref2.subTitle;
  return /*#__PURE__*/_jsxs(_StyledDiv5, {
    children: [/*#__PURE__*/_jsx(Title, {
      content: title,
      fontSize: "base",
      fontWeight: "semibold",
      twStyle: {
        "lineHeight": "1.5rem"
      }
    }), subTitle ? /*#__PURE__*/_jsx(Title, {
      content: subTitle,
      fontSize: "small",
      fontWeight: "normal",
      twStyle: {
        "lineHeight": "1.313rem"
      },
      textColor: "gray"
    }) : null]
  });
};

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-quick-guide___StyledDiv",
  componentId: "sc-1r0sr6g-0"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "2rem"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-quick-guide___StyledDiv2",
  componentId: "sc-1r0sr6g-1"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.5rem"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-quick-guide___StyledDiv3",
  componentId: "sc-1r0sr6g-2"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "1.5rem"
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-quick-guide___StyledDiv4",
  componentId: "sc-1r0sr6g-3"
})({
  "width": "fit-content",
  "borderRadius": "0.25rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(246 245 255 / var(--tw-bg-opacity))",
  "padding": "0.5rem"
});

var _StyledDiv5 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-quick-guide___StyledDiv5",
  componentId: "sc-1r0sr6g-4"
})({
  "display": "flex",
  "flexDirection": "column"
});